import ApiService from "./api.service";
const main = "/employeePhoto";

export default {
  getList: async function (data) {
    return ApiService.post(`${main}/list`, data);
  },
  getByIdType: async function (id) {
    return ApiService.get(`${main}/get-by-id/${id}`);
  },
  getById: async function (id) {
    return ApiService.getFile(`${main}/employee-photo/${id}`);
  },
  delete: async function (id) {
    return ApiService.delete(`${main}/delete/${id}`);
  },
  update: async function (data) {
    return ApiService.post(`${main}/update`, data);
  },
  create(file, employeeId) {
    let bodyFormData = new FormData();
    bodyFormData.append("file", file);
    const requestData = {
      method: "post",
      url: `${main}/create/${employeeId}`,
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" },
    };
    return ApiService.customRequest(requestData);
  },
  getPhotoArchive(id) {
    return ApiService.get(`/employeePhoto/list-archive/${id}`);
  },
};
